import { Navigate } from "react-router-dom";
import React from "react";
import { useUserState } from 'context/AdminContext';

export default function PrivateRoute({ children }) {
  var isUserAuthenticated = useUserState().isUserAuthenticated;

  return isUserAuthenticated ? children : <Navigate to="/login" />;
}
